import { EventEmitter } from "pixi.js";

export enum EnumRootEventBus {
  onVideoMode = "ON_VIDEO_MODE",
  setInfoSliderPage = "SET_INFO_SLIDER_PAGE",
  setInfoSliderPageWArr = "SET_INFO_SLIDER_PAGE_WITH_ARROW",
  setCurPage = "SET_CURRENT_PAGE",
  updateEdgeState = "UPDATE_EDGE_STATE",
  startIntroAnim = "START_INTRODUCTION_ANIMATION",
  completedIntroAnim = "COMPLETED_INTRODUCTION_ANIMATION",
  setRedPointTag = "SET_RED_POINT_TAG",
  setRedPointCoord = "SET_RED_POINT_COORD",
  setRefRadians = "SET_REFERANCE_RADIANS",
  getCircleCoord = "GET_CIRCLE_COORD",
  drawElements = "DRAW_ELEMENTS"
}

export const RootEventBus = new EventEmitter();